import { render, staticRenderFns } from "./facets-lite.vue?vue&type=template&id=6a64aca0&scoped=true&lang=pug&"
import script from "./facets-lite.vue?vue&type=script&lang=js&"
export * from "./facets-lite.vue?vue&type=script&lang=js&"
import style0 from "./facets-lite.vue?vue&type=style&index=0&id=6a64aca0&scoped=true&lang=scss&"
import style1 from "./facets-lite.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a64aca0",
  null
  
)

export default component.exports